/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedDescriptionAdditionalOptionsContent_item = {
    readonly leadTimeDisplay: string | null;
    readonly isCustomizable: boolean | null;
    readonly seller: {
        readonly isJewelrySeller: boolean | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_item">;
    readonly " $refType": "PdpSharedDescriptionAdditionalOptionsContent_item";
};
export type PdpSharedDescriptionAdditionalOptionsContent_item$data = PdpSharedDescriptionAdditionalOptionsContent_item;
export type PdpSharedDescriptionAdditionalOptionsContent_item$key = {
    readonly " $data"?: PdpSharedDescriptionAdditionalOptionsContent_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAdditionalOptionsContent_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDescriptionAdditionalOptionsContent_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "leadTimeDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCustomizable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isJewelrySeller",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '5bda56f76f41757be069f9baf9e607ea';
export default node;
